import { useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch {
      toast.error("Something went wrong, try again");
    } finally { setBusy(false); }
  };

  return (
    <Layout>
      <section className="max-w-md mx-auto px-6 py-16">
        <h1 className="heading text-4xl font-black uppercase tracking-tight">Forgot password</h1>
        {sent ? (
          <div className="mt-8 brut-border bg-white p-6">
            <p className="text-sm">If an account exists for <strong>{email}</strong>, we've sent a reset link. Check your inbox — the link expires in 60 minutes.</p>
            <Link to="/login" className="btn-ghost mt-6 inline-block">Back to sign in</Link>
          </div>
        ) : (
          <>
            <p className="text-[#555] mt-2">Enter the email on your account and we'll send a reset link.</p>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <div>
                <label className="mono text-xs uppercase tracking-[0.2em] font-bold">Email</label>
                <input data-testid="fp-email" required type="email" value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full mt-2 brut-border bg-white px-4 py-3" />
              </div>
              <button data-testid="fp-submit" disabled={busy} className="btn-primary w-full">
                {busy ? "Sending…" : "Send reset link"}
              </button>
            </form>
            <p className="mt-6 mono text-xs uppercase tracking-[0.2em] text-[#555]">
              <Link to="/login" className="text-[#C77E3C]">← Back to sign in</Link>
            </p>
          </>
        )}
      </section>
    </Layout>
  );
}
